export const DEFAULT_SHIPPING_PRICE = {
  LOCAL: "8.95",
  INTERNATIONAL: "24.95",
};
